import BreadCrumb from "components/common/BreadCrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { ClientAdvancesTable } from "./ClientAdvancesTable";
import { Link } from "react-router-dom";
import { getDocumentTitle } from "utils/helpers";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";
import AdvanceSummaryWidgets from "components/common/AdvanceSummaryWidgets";
import { getClientAdvanceSummary } from "features/ClientAdvances/services/ClientAdvanceService";
import { clientAdvanceStatusMap } from "features/ClientAdvances/constants/client-advance.constants";

const ClientAdvanceList = () => {
  document.title = getDocumentTitle("Client Advances");
  const { can } = useAccess();
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Client Advances" pageTitle="Finance" />
        <AdvanceSummaryWidgets
          fetchSummary={getClientAdvanceSummary}
          statusLabelMap={clientAdvanceStatusMap}
        />
        <Card>
          <CardHeader className="d-flex justify-content-between">
            <h5 className="card-title mb-0">Client Advance List</h5>
            {can(Permissions.CLIENT_ADVANCE.CREATE) ? (
              <Link to="/finance/client-advances/create" className="btn btn-primary">
                <i className="ri-add-line align-bottom me-1"></i> New Client Advance
              </Link>
            ) : null}
          </CardHeader>
          <CardBody>
            <ClientAdvancesTable />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default ClientAdvanceList;
